import i18n from 'i18next';

export const translation = (key) => i18n.t(key);
export default translation;